import { render } from "./Footer.vue?vue&type=template&id=06ff5559&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=06ff5559&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06ff5559"

export default script